import React from "react";
import App from "../App";

export default function home() {
  return (
    <div>
      <App />
    </div>
  );
}